import SimpleLightbox from "simple-lightbox"

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-lightbox]").forEach(element => {
    const lightbox = new SimpleLightbox({
      elements: element.querySelectorAll("a")
    })
  })
})
